<template>
  <b-modal id="game-modal-menu" v-model="modal" size="md" hide-footer centered>
    <video
      controls
      style="width: 100%"
      @error="handleError"
      @emptied="handleEmpty"
      @suspend="handleEmpty"
    >
      <source :src="videoUrl" type="video/mp4" />
      Sorry, your browser doesn't support embedded videos, but don't worry, you
      can
      <a :href="videoUrl">download it</a>
      and watch it with your favorite video player!
    </video>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      videoUrl: '',
      modal: false,
    };
  },
  methods: {
    handleError() {
      console.error('Error loading video');
      // this.modal = false; // Close the modal if there's an error
    },
    handleEmpty() {
      console.error('Error loading video empty');
      // this.modal = false; // Close the modal if there's an error
    },
  },
};
</script>

<style lang="scss" scoped></style>
